import { useState, useEffect, useMemo, useRef } from "react";

import { Stack, } from '@mui/material';
import "./App.css";

import PropTypes from "prop-types";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { CENTERAEKIA } from "../../config"
import AutoCompleteInput from './AutoCompleteInput'


export default function Index(props) {
  const { labelText,inicial, value, opciones, cargando, onChangeValue, variant,latitudLongitud,direccion,direccionPersona, ...res } = props;
  const [values, setValues] = useState(null);
  const [markers, setMarker] = useState(inicial?inicial: CENTERAEKIA);
  const [center,setCenter] = useState(inicial?inicial: CENTERAEKIA);



  useEffect(() => {


  }, [])


  const onMapClick = (e) => {
    setMarker({
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    });
    onChangeValue({
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    })
  };

  const direccionInfo = (res) => {
    direccion(res)
  }
  const puntosInfo = (res) => {
    latitudLongitud(res);
    setCenter(res);
    setMarker(res)
    onChangeValue(res)

  }

  return (
    <Stack spacing={3} width={'100%'} height={600} p={2}>
      <AutoCompleteInput
       latitudLongitud={puntosInfo}
       direccion={direccionInfo}
       direccionPersona={direccionPersona}

      />
      <GoogleMap
        center={center}
        mapContainerClassName="map-container"
        onClick={onMapClick}
        zoom={16}
      >


        {markers && <Marker
          position={{
            lat: parseFloat(markers.lat),
            lng: parseFloat(markers.lng)
          }} />}
      </GoogleMap>

    </Stack>

  );
}
Index.propTypes = {
  labelText: PropTypes.string,
  opciones: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  variant: PropTypes.oneOf(['filled', 'standard']),
  onChangeValue: PropTypes.func,
  cargando: PropTypes.bool,
  latitudLongitud: PropTypes.func,
  direccion: PropTypes.func
};
Index.defaultProps = {
  opciones: [],
  valor: null,
  cargando: true,
  variant: 'filled',
  labelText: '',
  onChangeValue: () => {

  },
  latitudLongitud: (value) => { },
  direccion: (value) => { },
};